import { render, staticRenderFns } from "./CriteriaItemForm.vue?vue&type=template&id=5cc63d27"
import script from "./CriteriaItemForm.vue?vue&type=script&lang=ts"
export * from "./CriteriaItemForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports